import { render, staticRenderFns } from "./ItemV2.vue?vue&type=template&id=1ce67036"
import script from "./ItemV2.vue?vue&type=script&lang=js"
export * from "./ItemV2.vue?vue&type=script&lang=js"
import style0 from "./ItemV2.vue?vue&type=style&index=0&id=1ce67036&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports